import { TypePolicy } from "@apollo/client";

import { expirationInfo } from "../../util/expiration";

export const fieldName = "expirationDateTime";

export default {
  merge: true,
  fields: {
    expiration: {
      read(_, { readField }) {
        return expirationInfo(readField(fieldName) as string);
      },
    },
  },
} as TypePolicy;
